@if (this.brands) {
  <mat-expansion-panel hideToggle class="category-filter box-shadow"
    [expanded]="true" (closed)="brandExpanded = false" (opened)="brandExpanded = true">
    <mat-expansion-panel-header >
      <mat-panel-title>{{ 'globalUi.filter.brands' | translate }}</mat-panel-title>
      <mat-panel-description fxFlex="">
        <span fxFlex=""></span>
        @if (!brandExpanded) {
          <img alt="" src="assets/icons/add-24px-2.svg">
        } @else {
          <img alt="" src="../../../../assets/icons/close-icon.svg" >
        }
      </mat-panel-description>
    </mat-expansion-panel-header>
    <mat-selection-list
      dense
      [(ngModel)]="selectedBrands"
      (ngModelChange)="applyFilter()"
      class="brand-content" >
      @for (brand of brands; track brand) {
        <mat-list-option
          [checkboxPosition]="'before'"
          [value]="brand.id"
          color="primary"
          >
          {{ brand.name }}
        </mat-list-option>
      }
    </mat-selection-list>
  </mat-expansion-panel>
}
